<ces-asset-breadcrumb [trail]="breadcrumbTrail()" />
<div class="p-(--padding-card) pt-(--space-2)">
  <div class="mb-(--space-4) flex justify-between items-center">
    <div class="text-h1">{{ 'navigation.measures' | transloco }}</div>
    <div class="flex gap-(--gap-normal)">
      @if (currentAssetId(); as assetId) {
        <ces-menu-button-secondary
          [hasPermission]="{ permissionId: PermissionScope.Measures, type: 'read', assetId: assetId }"
          icon="more_vert"
          [items]="actionsMenuItems()"
          menuStyleClass="ces-menu-align-right" />
        <ces-menu-button
          [hasPermission]="{ permissionId: PermissionScope.Measures, type: 'write', assetId: assetId }"
          icon="add"
          [label]="'common.buttons.add' | transloco"
          [items]="createMenuitems()" />
      }
    </div>
  </div>

  @if (!currentAssetId()) {
    <div class="p-(--padding-card) text-center bg-yellow-100 border border-yellow-300 rounded-(--radius-md) mb-(--space-4)">
      <p>{{ 'entities.measure.messages.noAssetSelected' | transloco }}</p>
    </div>
  }
  <div>
    <p-tabs [value]="activeTab()">
      <p-tablist>
        <p-tab value="manual" [routerLink]="['manual']">
          {{ 'entities.measure.tabs.manual' | transloco }}
        </p-tab>
        <p-tab value="automatic" [routerLink]="['automatic']">
          {{ 'entities.measure.tabs.automatic' | transloco }}
        </p-tab>
        <p-tab value="auscultation-information" [routerLink]="['auscultation-information']">
          {{ 'entities.measure.tabs.auscultation' | transloco }}
        </p-tab>
        <p-tab value="analysis-post" [routerLink]="['analysis-post']">
          {{ 'entities.measure.tabs.analysisPosts' | transloco }}
        </p-tab>
      </p-tablist>
    </p-tabs>
    <div class="mt-(--space-4)">
      <router-outlet (activate)="onTabActivate($event)" (deactivate)="onTabDeactivate()" />
    </div>
  </div>
</div>
